module.exports = __webpack_public_path__ + "img/Lemonpeel angelfish.829ee036.png";